const AppleUrl =
  'https://apps.apple.com/au/app/special-gift-cards/id1585917288';
const GoogleUrl =
  'https://play.google.com/store/apps/details?id=au.com.special';

export { AppleUrl, GoogleUrl };
